export async function revokeAccessTokenOnServer(
  accessToken: string | undefined,
  logoutUrl: string | undefined
): Promise<void> {
  if (!accessToken || !logoutUrl) {
    return;
  }

  try {
    await fetch(logoutUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  } catch {
    // Continue with client logout even if the server call fails.
  }
}

export function buildExternalAuthLogoutUrl(): string | undefined {
  const base = process.env.REACT_APP_EXTERNAL_API_BASEURL;
  if (!base) {
    return undefined;
  }
  return `${base.replace(/\/$/, "")}/api/Auth/Logout`;
}
